import Styles from '../TitleSelector.module.scss'
import { Button } from 'blaze-ui/Button'
import { Edit1, ArrowRefresh } from 'blaze-ui/icons/20'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'

interface ActionButtonsProps {
  onWriteOwn: () => void
  onRegenerate: () => void
}

export const ActionButtons = ({ onWriteOwn, onRegenerate }: ActionButtonsProps) => (
  <MobileWizard.Section>
    <div className={Styles.actionButtons}>
      <Button variant="tertiary" size="md" frontIcon={Edit1} onPress={onWriteOwn} fullWidth>
        Write Your Own
      </Button>

      <Button
        variant="ghost"
        size="md"
        frontIcon={ArrowRefresh}
        onPress={onRegenerate}
        className={Styles.regenerateButton}
        fullWidth
      >
        Regenerate
      </Button>
    </div>
  </MobileWizard.Section>
)
